// Renamed from GiftLandingPage-Emotional.js
import React from 'react';
import GiftLandingPageEmotional from './GiftLandingPage-Emotional';

const PreciousSleepGift = () => {
  return <GiftLandingPageEmotional />;
};

export default PreciousSleepGift;
